import { TYPE_SIZES, TYPES_BUTTON } from '../../utils/globalConst.js';
import Loader from '../Loader/Loader.vue.js';

//
var script = {
  name: 'ButtonControl',
  components: {
    Loader: Loader
  },
  props: {
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: TYPE_SIZES.normal.value
    },
    isAddedDisabledClassName: {
      type: Boolean,
      default: false
    },
    isWhiteLoader: {
      type: Boolean,
      default: false
    },
    isBlock: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'default' // more || secondary || 'link' || 'link-dashed'

    },
    isMultiLines: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    rootClass: function rootClass() {
      var obj;

      return [( obj = {}, obj[TYPES_BUTTON.secondary.className] = this.type === TYPES_BUTTON.secondary.value, obj[TYPES_BUTTON.more.className] = this.type === TYPES_BUTTON.more.value, obj[TYPES_BUTTON.link.className] = this.type === TYPES_BUTTON.link.value, obj[TYPES_BUTTON.linkDashed.className] = this.type === TYPES_BUTTON.linkDashed.value, obj[TYPE_SIZES.small.className] = this.size === TYPE_SIZES.small.value, obj[TYPE_SIZES.extraSmall.className] = this.size === TYPE_SIZES.extraSmall.value, obj[TYPE_SIZES.large.className] = this.size === TYPE_SIZES.large.value, obj._loading = this.loading, obj._disabled = this.isAddedDisabledClassName, obj._block = this.isBlock, obj['_multi-lines'] = this.isMultiLines, obj )];
    }

  },

  mounted: function mounted() {
    var _this$$refs, _this$$refs2;

    if ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.root.classList.contains('_two-lines')) {
      console.warn('[ButtonControl] className "_two-lines" is deprecated');
    }

    if ((_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : _this$$refs2.root.classList.contains('_split')) {
      console.warn('[ButtonControl] className "_split" is deprecated');
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }

  }
};

export default script;
